import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import { Button } from 'react-bootstrap'
import useConfigureDiscussion from '../../discussions/use-configure-discussion'

const MessageButton = ({
    recipientId,
    subject,
    ...props
}) => {
    const { canMessage } = useCurrentUser()
    const { showDiscussionConfiguration } = useConfigureDiscussion({ topic: subject, users: [recipientId]})

    if (!canMessage) {
        return null
    }

    return (
        <React.Fragment>
            <Button onClick={() => showDiscussionConfiguration()} {...props} />
        </React.Fragment>
    )
}

export default MessageButton